var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq"},[_c('div',{staticClass:"post-content"},[_c('div',{staticClass:"text-center title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.detail)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }